module.exports = __webpack_public_path__ + "img/cross-red.dad172a1.svg";